export enum ActivityEnum {
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
}
